import { Controller } from '@hotwired/stimulus'
import { format } from 'date-fns'

const DATE_FNS_FORMAT = 'd. MMM yyyy'

export default class extends Controller {
  static targets = ['dateInput', 'hourSelect', 'minuteSelect']
  static values = {
    defaultDate: String,
    defaultHour: Number,
    defaultMinute: Number,
    earliestDate: String
  }

  useDefaultTimestamp() {
    this.dateInputTarget.value = this.defaultDateValue
    this.dateInputTarget.dispatchEvent(
      new CustomEvent('dateinput', { bubbles: true })
    )
    this.hourSelectTarget.value = this.defaultHourValue
    this.minuteSelectTarget.value = this.defaultMinuteValue
  }

  useNow() {
    const { day, month, year, hour, minute } = this.#currentOsloTime()
    const date = new Date(year, month - 1, day)
    this.#setDate(format(date, DATE_FNS_FORMAT))
    this.hourSelectTarget.value = hour
    this.minuteSelectTarget.value = Math.floor(minute / 15) * 15
  }

  useEndOfDay() {
    this.hourSelectTarget.value = 23
    this.minuteSelectTarget.value = 59
  }

  useEarliestPossible() {
    this.#setDate(this.earliestDateValue)
    this.hourSelectTarget.value = 0
    this.minuteSelectTarget.value = 0
  }

  #currentOsloTime() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Oslo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(new Date())
    return {
      day: parseInt(parts.find((p) => p.type === 'day').value),
      month: parseInt(parts.find((p) => p.type === 'month').value),
      year: parseInt(parts.find((p) => p.type === 'year').value),
      hour: parseInt(parts.find((p) => p.type === 'hour').value),
      minute: parseInt(parts.find((p) => p.type === 'minute').value)
    }
  }

  #setDate(value) {
    this.dateInputTarget.value = value
    this.dateInputTarget.dispatchEvent(
      new CustomEvent('dateinput', { bubbles: true })
    )
  }
}
